import { HealthCheckService } from '@talon/web/lib/api';
import { runtimeConfig } from '../config/runtime';

declare global {
  interface Window {
    /** Git SHA of the running web build - read by the post-deploy smoke tests. */
    __TALON_RELEASE__?: string;
  }
}

/** Git SHA of the deployed build, from the production container's runtime config ('dev' locally). */
export const WEB_RELEASE = runtimeConfig.RELEASE || 'dev';

export const shortRelease = (release: string) => (release === 'dev' ? release : release.slice(0, 7));

/** e.g. "Web a1b2c3d · API e4f5g6h" */
export const formatBuildLabel = (webRelease: string, apiRelease: string | null) =>
  `Web ${shortRelease(webRelease)} · API ${apiRelease ? shortRelease(apiRelease) : 'unknown'}`;

/** The API's deployed release, or null if it can't be reached. */
export const fetchApiRelease = async (): Promise<string | null> => {
  try {
    const { release } = await HealthCheckService.healthCheck();
    return release || null;
  } catch {
    return null;
  }
};
